export default __webpack_public_path__ + "static/media/step1.588534a8.jpg";